const Footer = () => {
  return (
    <footer>
      <p className="py-4">Created By <span>Abo Lila</span></p>
    </footer>
  )
}

export default Footer
